import React from 'react';
import { DocumentHead, PageTemplate } from 'lib/components';
import { Main } from './main/Main';
import { useTranslation } from 'react-i18next';

export const Personalization = () => {
  const { t } = useTranslation();
  return (
    <>
      <DocumentHead title={t('Personalization')} />
      <PageTemplate main={<Main />} />
    </>
  );
};
